<template>
    <el-dialog
            class="selfModal"
            :modal="false"
            title="查看文件权限"
            :close-on-click-modal="false"
            :visible="jurisData.state"
            width="45%"
            @close="closeModal()"
    >
        <div style="min-height:300px;max-height:450px; overflow-y: auto" v-loading = 'treeLoging'>
            <el-tree :data="treeData"
                     default-expand-all
                     empty-text="暂无数据权限"
                     :props="defaultProps"
            ></el-tree>
        </div>
       <!-- <div v-else class="noneData"  v-loading = 'treeLoging'>
            暂无数据权限
        </div>-->
        <span slot="footer" class="dialog-footer">
             <el-button  @click="closeModal">关闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import {jurisdiction } from '@/api/portrayal/policy'
    // import {jurisdictionS } from '@/api/portrayal/studentFile'
  export default {
     name: "fileJurisModal",
     props: {
         jurisData: {
             type: Object,
                 required: true
         }
     },
     data(){
         return{
             treeLoging: false,
             treeData: [],
             defaultProps: {
                 children: 'children',
                 label: 'name'
             }
         }
     } ,
      methods:{
         getTreeData(id){
             this.treeLoging = true
             jurisdiction(id).then(res => {
                 this.treeLoging = false
                 this.treeData = res.data.data
             })
         },
        //   getTreeDataS(id){
        //       this.treeLoging = true
        //       jurisdictionS(id).then(res => {
        //           this.treeLoging = false
        //           this.treeData = res.data.data
        //       })
        //   },
          closeModal(){
            this.$emit('closeJuris',false)
          }
      }
  }
</script>

<style lang="less" scoped>
.noneData{
    height: 200px;
    text-align: center;
    font-size: 18px;
    line-height: 200px;
}
</style>